import { CashRegister } from "@/types/shop";

const docStyles = document.documentElement.style;

const updateShopTheme = (cashRegister: CashRegister) => {
  const {
    shop: {
      property: { theme },
    },
  } = cashRegister;
  docStyles.setProperty("--primary-hotel-color", theme.primaryColor);
  docStyles.setProperty("--light-hotel-color", theme.lightColor);
  docStyles.setProperty("--dark-hotel-color", theme.darkColor);
  docStyles.setProperty("--cta-hotel-color", theme.ctaButtonColor);
  docStyles.setProperty("--search-button-color", theme.searchButtonColor);
};

export { updateShopTheme };
